import React from "react";
import { graphql } from "@apollo/client/react/hoc";
import { gql } from "@apollo/client";
import { Loading } from "@website2018/da-dobsonville";

class ProvinceContainer extends React.Component {
  render() {
    const { error, loading, provincial } = this.props;

    if (loading) return <Loading />;
    if (error) return <p>{error}</p>;

    return this.props.render(provincial.province);
  }
}

const PAGE_QUERY = gql`
  query getPage($site: String!, $slug: String) {
    provincial(site: $site) {
      province(slug: $slug) {
        id
        stickers {
          title
          color
          icon
          background {
            url
          }
          text
        }
        testimonials {
          section_heading
          testimonial {
            headline
            attribution
            text
            photo {
              url
            }
          }
        }
        wwg {
          governments {
            id
            slug
            title {
              rendered
            }
            excerpt {
              rendered
            }
            featured_media {
              source_url
            }
          }
          hero {
            headline
            image_hotspot
            cta_type
            group_headline
            focus_point
            background_image {
              url
            }
          }
          content
        }
      }
    }
  }
`;

const withProvince = graphql(PAGE_QUERY, {
  options: (props) => {
    let url;
    if (process.browser) {
      url = window.location.host;
    } else {
      url = props.url;
    }

    return {
      variables: {
        slug: props.slug || null,
        id: props.id || null,
        site: url,
      },
    };
  },
  props: ({ data, post }) => ({ ...data }),
});

export default withProvince(ProvinceContainer);
